import { z } from "zod";
import { UserSchema } from "./User";

export const ManagerSchema = UserSchema.pick({
    id: true,
    name: true,
    email: true,
    enabled: true,
}).extend({
    level: z.string().nullable(),
})

export type Manager = z.infer<typeof ManagerSchema>;
